import { useFeatureFlags } from 'utils/features';

// PHOTO_VERIFICATION_PPE is a LaunchDarkly flag that enables the entire PPE feature set
export const usePhotoVerificationPpeEnabled = () => useFeatureFlags('PHOTO_VERIFICATION_PPE');

export const usePhotoVerificationPpeFaceCoverEnabled = () =>
  useFeatureFlags('PHOTO_VERIFICATION_PPE', 'PHOTO_VERIFICATION_PPE_FACE_COVER');

export const usePhotoVerificationPpeHeadCoverEnabled = () =>
  useFeatureFlags('PHOTO_VERIFICATION_PPE', 'PHOTO_VERIFICATION_PPE_HEAD_COVER');

export const usePhotoVerificationPpeSafetyVestEnabled = () =>
  useFeatureFlags('PHOTO_VERIFICATION_PPE', 'PHOTO_VERIFICATION_PPE_SAFETY_VEST');

export const usePhotoVerificationPpeEyeProtectionEnabled = () =>
  useFeatureFlags('PHOTO_VERIFICATION_PPE', 'PHOTO_VERIFICATION_PPE_EYE_PROTECTION');

export const usePhotoVerificationPpeAnyScanEnabled = () => {
  const anyPpeScanEnabled = [
    usePhotoVerificationPpeFaceCoverEnabled(),
    usePhotoVerificationPpeHeadCoverEnabled(),
    usePhotoVerificationPpeSafetyVestEnabled(),
    usePhotoVerificationPpeEyeProtectionEnabled(),
  ].some(Boolean);

  return anyPpeScanEnabled;
};
